import { UseQueryResult } from '@tanstack/react-query';

/** Matches `ManagedIntegration.RELEASE_CHANNELS` (stable / dev). */
export type ManagedIntegrationReleaseChannel = 'stable' | 'dev';

/** Default when Cloud Connector (ICC) is enabled; matches backend `STABLE_RELEASE_CHANNEL`. */
export const DEFAULT_MANAGED_INTEGRATION_RELEASE_CHANNEL: ManagedIntegrationReleaseChannel =
  'stable';

export type ManagedIntegrationList = {
  author: string;
  category: string;
  description: string;
  developedByPaperlessParts: boolean;
  didLogIntoEci: boolean;
  integratedSoftwareName: string;
  integrationTemplateId: number;
  integrationVersion: string;
  name: string;
  supportContact: string;
  uuid: string;
  updated: string; // ISO formatted datetime
  created: string; // ISO formatted datetime
  isActive: boolean;
  isIccEnabled: boolean;
  isIccCompatible: boolean;
  iccSetupComplete: boolean;
  lastActionDate: string; // ISO formatted datetime
  logo: {
    id: string;
    original: string;
    thumbnail: string;
  } | null;
  showStatusIndicator: boolean;
  requiresExternalRobotUser: boolean;
  isRobotConnected: boolean;
  robotUserUuid: string | null;
  isCoreProductControlled: boolean;
  internalProductizedName: string | null;
  releaseChannel: ManagedIntegrationReleaseChannel | null;
};

// Integration Action Definition
export type IntegrationActionDefinition = {
  id: number;
  name: string;
  description: string;
  isEnabled: boolean;
};

// Extended Type: ManagedIntegrationDetails
export type ManagedIntegration = ManagedIntegrationList & {
  configurationParameters: Record<string, any>;
  integrationActionDefinitions: IntegrationActionDefinition[];
  status: string;
  iccSetupTokenExpiration: string | null;
  iccSshTunnelStatus: string | null;
  iccSshTunnelStatusExpiration: string | null;
};

export type ManagedIntegrationListQueryResult = UseQueryResult<
  ManagedIntegrationList[]
>['data'];
